import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import Image from "next/image";

export const ShowMessageToast = ({ messageData, onOpenChat }) => {
  const msg = messageData?.data?.messageNotificationDispatch;
  if (!msg) return;

  const initials = `${msg?.driver?.first_name?.[0] || ""}${msg?.driver?.last_name?.[0] || ""}`;

  return (
    <div
      className="flex items-center text-white cursor-pointer p-0"
      onClick={() => {
        if (msg?.channel_id) {
          onOpenChat(msg?.channel_id, msg?.driver);
        }
      }}
    >
      <div className="min-w-[50px] min-h-[50px] w-[50px] h-[50px] mr-4">
        <Avatar className="w-[50px] h-[50px] border border-white">
          <AvatarImage src={msg?.driver?.profile_picture} />
          <AvatarFallback className="bg-gray-500 text-sm">
            {initials}
          </AvatarFallback>
        </Avatar>
      </div>

      <div className="flex-1 min-w-0 overflow-hidden">
        <p className="font-medium text-sm truncate">
          {msg?.driver?.first_name} {msg?.driver?.last_name}
        </p>
        <p className="text-sm text-gray-400 line-clamp-2 break-words">
          {msg?.message_type === "text" ? msg?.message : "sent a file"}
        </p>
      </div>
    </div>
  );
};
